import React from 'react';

import {
  createSidebarModalNavigationControlClassName,
  createSidebarModalNavigationLayoutClassName,
} from './sidebarModalNavigationStyles';

type ControlProps = {
  active?: boolean;
  onPress(): void;
};

export const SidebarModalNavigationControlComponent: React.FC<ControlProps> = (
  props
) => {
  const { children, active, onPress } = props;

  const buttonClassName = createSidebarModalNavigationControlClassName(
    'button',
    { active }
  );

  const handleClick = React.useCallback(() => {
    onPress();
  }, [onPress]);

  return (
    <button className={buttonClassName} onClick={handleClick}>
      {children}
    </button>
  );
};

export const SidebarModalNavigationLayoutComponent: React.FC = (props) => {
  const { children } = props;

  const wrapperClassName = createSidebarModalNavigationLayoutClassName(
    'wrapper'
  );

  return <div className={wrapperClassName}>{children}</div>;
};
